import { CountryStoreEnum, StoresEnum } from '@ubnt/link-core/enums';
import { DEFAULT_COUNTRY } from '@ubnt/wifi-calculator/utils/regulatoryLimits';
import config from 'config';
import { isEnumKey } from 'utils/isEnumKey';

export const getStoreCountry = (country: string) => {
  if (isEnumKey(CountryStoreEnum, country)) {
    return CountryStoreEnum[country] as ValuesOf<typeof StoresEnum>;
  }
  return CountryStoreEnum[DEFAULT_COUNTRY] as ValuesOf<typeof StoresEnum>;
};

export const LIST_PRICES_ENDPOINT =
  config.ISP_DESIGN_CENTER_URL ? new URL('/api/v1/store/listPrices', config.ISP_DESIGN_CENTER_URL) : null;
